// extracted by mini-css-extract-plugin
export var childrenContainer = "_88-0";